<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $tc('delete_ip') }}?
        </v-card-title>
        <v-card-text>
          {{ $t('confirm_ip_delete') }}
          <strong>{{ ip }}</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click.native="closeModal">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="text_red" text @click.native="deleteIp">
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  props: {
    ip: {
      type: String,
      required: false,
      default: () => null
    },
    open: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data () {
    return {
      dialog: this.open
    }
  },
  computed: {
    syslog () {
      return this.$store.state.hsm.netInfo.syslog
    }
  },
  methods: {
    closeModal () {
      this.dialog = false
      this.$emit('close')
    },
    deleteIp () {
      let rhost0 = this.syslog[0] === undefined ? '' : this.syslog[0]
      let rhost1 = this.syslog[1] === undefined ? '' : this.syslog[1]
      let rhost2 = this.syslog[2] === undefined ? '' : this.syslog[2]
      let rhost3 = this.syslog[3] === undefined ? '' : this.syslog[3]

      if (this.ip === rhost0) {
        rhost0 = ''
      } else if (this.ip === rhost1) {
        rhost1 = ''
      } else if (this.ip === rhost2) {
        rhost2 = ''
      } else if (this.ip === rhost3) {
        rhost3 = ''
      }

      this.$store
        .dispatch('hsm/set_syslog_rh', {
          body: {
            rhost0,
            rhost1,
            rhost2,
            rhost3
          }
        })
        .then(() => {
          this.$notify.success({})
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
        .finally(() => {
          this.loading = false
          this.closeModal()
        })
    }
  },
  watch: {
    open (val) {
      this.dialog = val
    }
  }
}
</script>
